module.exports = __webpack_public_path__ + "static/img/qmwallet1-discount-bg.32622497.png";